import { render, staticRenderFns } from "./ExportItems.vue?vue&type=template&id=4c65610a&lang=pug"
import script from "./ExportItems.vue?vue&type=script&lang=js"
export * from "./ExportItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports